import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-atm',
  templateUrl: './atm.component.html',
  styleUrls: ['./atm.component.css'],
})
export class ATMComponent implements OnInit {
  public cuentaBancolombia: string;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit() {
    this.cuentaBancolombia = this.data.cuentaBancolombia.value;
  }

  public closedModal() {
    this.dialog.closeAll();
  }
}
